import { AuthInformation } from './model';

const SECURITY_TIME_TO_AVOID_ERROR_DUE_TO_REFRESH_DURING_CALL_API = 10;

export const hasAccessTokenExpired = (authInformation: AuthInformation): boolean => {
  const elapsedTime = Date.now() - authInformation.requestedAt;
  return elapsedTime > (authInformation.expiresIn - SECURITY_TIME_TO_AVOID_ERROR_DUE_TO_REFRESH_DURING_CALL_API) * 1000;
};

export const parseJwtPayload = <T>(token: string): T => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map((char) => '%' + ('00' + char.charCodeAt(0).toString(16)).slice(-2))
      .join(''),
  );

  return JSON.parse(jsonPayload) as T;
};
